import { render, staticRenderFns } from "./DoYouWantImmediateCash.vue?vue&type=template&id=1f81e841&scoped=true&"
import script from "./DoYouWantImmediateCash.vue?vue&type=script&lang=js&"
export * from "./DoYouWantImmediateCash.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f81e841",
  null
  
)

export default component.exports